import type { FilterShipmentsDescription } from "@/Shared/ShipmentFilter/Dialogs/Internal/FilterShipmentsDialogBody";
import type { SortShipmentOptions } from "@/Shared/Shipment/SortShipmentOptions";

export function shipmentFilterRenderDescriptionAsQueryParams(
  filterShipmentDescription: FilterShipmentsDescription,
  sort: SortShipmentOptions,
): string {
  const parts: Array<string> = [];
  Object.entries(filterShipmentDescription).forEach(([key, value]) => {
    if (value !== undefined) {
      parts.push(`${key}=${encodeURIComponent(value)}`);
    }
  });

  parts.push(`sort=${sort}`);

  return parts.join("&");
}
